import React from 'react';

function BranchSelectField() {
  return '';
}

export default BranchSelectField;
